import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { DataSource, UploadedSessionData } from "@/types/common.types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

type UploadStyleIdsVariables = {
  styleIds: string[];
  jobName: string;
  dataSource: DataSource;
};

type UploadStyleIdsResponse = UploadedSessionData & {
  userId: number;
  uploadTime: string;
  originalFileName: string;
  storageFileName: null;
  status: string;
  createdBy: null;
  createdDate: string;
  lastModifiedBy: null;
  lastModifiedAt: string;
  uploadedStyles: [];
};

const uploadStyleIds = async ({
  styleIds,
  jobName,
  dataSource,
}: UploadStyleIdsVariables): Promise<UploadStyleIdsResponse> => {
  return apiClient
    .post(ENDPOINTS.UPLOAD_STYLE_IDS, {
      json: { styleIds, jobName, dataSource },
    })
    .json<UploadStyleIdsResponse>();
};

export const useUploadStyleIdsMutation = (
  options?: UseMutationOptions<
    UploadStyleIdsResponse,
    Error,
    UploadStyleIdsVariables
  >
) => {
  return useMutation({
    mutationFn: uploadStyleIds,
    ...options,
  });
};
